export default __webpack_public_path__ + "static/media/NeilTionson.31589ed9.png";